// App-level tunables (branding, NFT splitting, polling)
export const APP = {
  name: 'Adrenaline NFT',
  tagline: 'Trade. Earn. Ascend.',
  nftChunkStep: 10,        // NFT denominations are multiples of $10
  pollIntervalMs: 15000,   // user data refresh cadence
  toastDurationMs: 4500,
  splashMinMs: 1400        // minimum splash time so animation reads
};

// GIF pools
export const NFT_GIFS = Array.from({ length: 12 }, (_, i) => `/assets/nfts/n${i + 1}.gif`);
export const USER_GIFS = Array.from({ length: 10 }, (_, i) => `/assets/users/u${i + 1}.gif`);
export const LOGO = '/assets/logo/logo.png';
export const LOGO_ANIM = '/assets/logo/logo.gif';
